import { ApiError } from '../api';
import { TUR_BILGI_METIN as M } from '../metin/turBilgi';
import type { FiyatCevabi, GonderimCevabi, GonderimIstegi, KanalDurumu, PdfCevabi, PdfIstegi, Secim, TurAramaCevabi, TurBilgisi } from './tipler';

export const ornekModu = import.meta.env.VITE_TUR_BILGI_ORNEK === '1';

/** api.ts ile aynı oturum, CSRF ve hata gövdesi deseni. İptal sinyali tüm okumalara taşınır. */
async function istek<T>(yol: string, signal?: AbortSignal, veri?: unknown): Promise<T> {
  const method = veri === undefined ? 'GET' : 'POST';
  const csrf = /(?:^|;\s*)mbd_csrf=([^;]+)/.exec(document.cookie)?.[1];
  const response = await fetch(`/api/v1/tour-factsheet${yol}`, {
    method, signal, credentials: 'include',
    headers: { 'content-type': 'application/json', ...(method === 'POST' ? { 'x-csrf-token': csrf ? decodeURIComponent(csrf) : '' } : {}) },
    ...(veri === undefined ? {} : { body: JSON.stringify(veri) }),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const failure = body as { message?: string | string[]; detail?: string; code?: string; correlationId?: string; reason?: string };
    throw new ApiError(response.status, (Array.isArray(failure.message) ? failure.message.join('. ') : failure.message ?? failure.detail ?? failure.reason) || M.hata, failure.code, failure.correlationId, failure.reason);
  }
  return body as T;
}

export const turBilgiApi = {
  ara: async (q: string, signal?: AbortSignal): Promise<TurAramaCevabi> => ornekModu
    ? (await import('./ornekVeri')).ornekAra(q) : istek(`/tours?q=${encodeURIComponent(q)}`, signal),
  tur: async (turNo: string, signal?: AbortSignal): Promise<TurBilgisi> => ornekModu
    ? (await import('./ornekVeri')).ornekTur(turNo) : istek(`/tours/${encodeURIComponent(turNo)}`, signal),
  durum: async (signal?: AbortSignal): Promise<KanalDurumu> => ornekModu
    ? (await import('./ornekVeri')).ornekDurum : istek('/status', signal),
  fiyat: async (secim: Secim, signal?: AbortSignal): Promise<FiyatCevabi> => ornekModu
    ? (await import('./ornekVeri')).ornekFiyat(secim) : istek('/quote', signal, secim),
  pdf: (veri: PdfIstegi, signal?: AbortSignal): Promise<PdfCevabi> => ornekModu
    ? Promise.reject(new Error(M.ornekIslemYok)) : istek('/pdf', signal, veri),
  gonder: (id: string, kanal: 'email' | 'whatsapp', veri: GonderimIstegi, signal?: AbortSignal): Promise<GonderimCevabi> => ornekModu
    ? Promise.reject(new Error(M.ornekIslemYok)) : istek(`/pdf/${encodeURIComponent(id)}/${kanal}`, signal, veri),
};
